import { type WebAuthMode } from './types/web-auth-mode.type';
import { type WebRuntimeAuthConfig } from './types/web-runtime-auth-config.interface';

interface RawWebRuntimeConfig {
  readonly authMode?: string;
  readonly environment?: string;
  readonly productName?: string;
  readonly webBaseUrl?: string;
  readonly apiBaseUrl?: string;
  readonly customerPublishableKey?: string;
  readonly reservationQaTermsUrl?: string;
}

declare global {
  interface Window {
    __NEXUS_WEB_CONFIG__?: RawWebRuntimeConfig;
  }
}

const DEFAULT_AUTH_MODE: WebAuthMode = 'clerk';

export function readWebRuntimeAuthConfig(): WebRuntimeAuthConfig {
  const rawConfig: RawWebRuntimeConfig = readRawWebRuntimeConfig();
  const authMode: WebAuthMode = DEFAULT_AUTH_MODE;
  return {
    authMode,
    environment: normalizeString(rawConfig.environment) || 'local',
    productName: normalizeString(rawConfig.productName) || 'Molibra',
    webBaseUrl: normalizeString(rawConfig.webBaseUrl),
    apiBaseUrl: normalizeString(rawConfig.apiBaseUrl),
    customerPublishableKey: normalizeString(rawConfig.customerPublishableKey),
  };
}

function readRawWebRuntimeConfig(): RawWebRuntimeConfig {
  const fromWindow: RawWebRuntimeConfig =
    typeof window !== 'undefined' && window.__NEXUS_WEB_CONFIG__
      ? window.__NEXUS_WEB_CONFIG__
      : {};

  return fromWindow;
}

function normalizeString(value: string | undefined): string {
  if (typeof value !== 'string') {
    return '';
  }
  return value.trim();
}
